module.exports = __webpack_public_path__ + "media/images/icon__warning-1d5a56a16da390ea80cfef624d4f7882.png";